import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      &:hover {\n        ",
        " {\n          ",
        "\n        }\n      }\n\n      ",
        " {\n        ",
        "\n\n        &:nth-of-type(1) {\n          ",
        "\n        }\n\n        &:nth-of-type(2) {\n          opacity: 0;\n        }\n\n        &:nth-of-type(3) {\n          ",
        "\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  position: absolute;\n  right: 0;\n\n  .focus-trap {\n    display: block;\n    height: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  width: 100%;\n\n  transition: ",
        ";\n  transition-property: transform, opacity, background, width;\n\n  &:nth-of-type(1) {\n    margin-bottom: 5px;\n  }\n\n  &:nth-of-type(2) {\n    margin-bottom: 5px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Button } from "@miro-site/core";
import styled, { css } from "styled-components";
import animation from "@miro-site/design-tokens/src/foundation/animation";
import { isDarkTheme } from "../utils";
var BurgerButton = styled(Button).withConfig({
    componentId: "sc-cbcf575c-0"
})(_templateObject1(), function(props) {
    return props.theme.normalizeStyles({
        width: props.theme.header.burger.size,
        ":focus": _object_spread({}, props.theme.focus.outlines.withOffset)
    });
}, function(param) {
    var $isMobileMenuOpened = param.$isMobileMenuOpened;
    return $isMobileMenuOpened && css(_templateObject(), BurgerLine, function(props) {
        return props.theme.normalizeStyles({
            background: props.theme.header.burger.hoverColor
        });
    }, BurgerLine, function(props) {
        return props.theme.normalizeStyles({
            background: props.theme.header.burger.activeColor
        });
    }, function(props) {
        return props.theme.normalizeStyles({
            transform: "rotate(45deg) translateX(5px) translateY(5px)"
        });
    }, function(props) {
        return props.theme.normalizeStyles({
            transform: "rotate(-45deg) translateX(5px) translateY(-5px)"
        });
    });
});
var BurgerButtonLines = styled(Box).attrs({
    $styles: {
        position: "absolute",
        left: 0,
        right: 0,
        top: "50%",
        transform: "translateY(-50%)"
    }
}).withConfig({
    componentId: "sc-cbcf575c-1"
})(_templateObject2());
var BurgerLine = styled(Box).attrs({}).withConfig({
    componentId: "sc-cbcf575c-2"
})(_templateObject3(), function(param) {
    var theme = param.theme, $appearance = param.$appearance;
    return theme.normalizeStyles({
        background: isDarkTheme($appearance) ? theme.header.burger.activeColor : theme.header.burger.color,
        height: theme.header.burger.line.height,
        borderRadius: theme.header.burger.line.radius
    });
}, animation.transitionDuration);
var BurgerMenu = function(props) {
    return /*#__PURE__*/ _jsx(BurgerButton, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsxs(BurgerButtonLines, {
            children: [
                /*#__PURE__*/ _jsx(BurgerLine, {
                    $appearance: props.appearance
                }),
                /*#__PURE__*/ _jsx(BurgerLine, {
                    $appearance: props.appearance
                }),
                /*#__PURE__*/ _jsx(BurgerLine, {
                    $appearance: props.appearance
                })
            ]
        })
    }));
};
export default BurgerMenu;
